import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';
import { issueTypesLabelMap } from '../../../../../../../../core/projects.selectors';
import * as fromRoot from '../../../../../../../../../../state/app.state';
import { isIssueStageStatus } from '../../../../../../../../../../shared/helpers/issue-workflow';

@Component({
    selector: 'app-consolidated-report-issues-summary-card',
    templateUrl: './consolidated-report-issues-summary-card.component.html',
    styleUrls: ['./consolidated-report-issues-summary-card.component.scss'],
    standalone: false
})
export class ConsolidatedReportIssuesSummaryCardComponent implements OnInit, OnDestroy {
  @Input() issue: any;
  issueTypesLabelMap: any = {
    standard: 'Standard',
    environment: 'Environment',
    safety: 'Safety',
    'as-built': 'As built',
  };
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private store: Store<fromRoot.State>,
  ) {
  }

  ngOnInit() {
    this.store.select(issueTypesLabelMap)
      .pipe(takeUntil(this.onDestroy))
      .subscribe((d) => {
        if (Object.keys(d).length > 0) {
          this.issueTypesLabelMap = d;
        }
      });
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }

  /**
   * The plain open / closed pill stands unless the status is a
   * contractor-workflow stage, which app-issue-stage-chip shows instead: one
   * status pill either way.
   */
  get isStageStatus(): boolean {
    return isIssueStageStatus(this.issue?.status);
  }
}
